import { render } from "./mainSelector.vue?vue&type=template&id=76ed60c0"
import script from "./mainSelector.vue?vue&type=script&lang=js"
export * from "./mainSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__